<sm-title-bar pageTitle="{{ 'employee_invitation.title' | translate }}" [headerCustomTemplate]="addButton" [backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field" >
      <button mat-flat-button color="accent" (click)="addNewEmployee()">
        {{ 'employee_invitation.add_new' | translate }}
        <mat-icon class="material-icons-round" [inline]="true"
          >person_add</mat-icon
        >
      </button>
     
    </div>
  </ng-template>
</sm-title-bar>


<div class="stat-cards row row-cols-xl-4 row-cols-lg-3 g-4" *ngIf="employeeData.length > 0 && !loader">
  
  <div class="col" *ngFor="let item of employeeData">
    <mat-card  appearance="outlined"  class="stats_c" (click)="viewDetails(item.requestHashId)">
      <mat-card-title-group class="align-items-center">
        <mat-card-title>{{item.toName}}</mat-card-title>
        <mat-card-subtitle class="m-0">{{item.toPhone}}</mat-card-subtitle>
       
        <mat-card-subtitle style="margin-bottom: 0px; margin-top: 10px;">Rs. {{item.joiningSalary}}</mat-card-subtitle>
        <mat-card-subtitle class="m-0">{{item.creationDate | date}}</mat-card-subtitle>
        <div class="card-icon d-flex justify-content-center align-items-center">
          <mat-icon color="primary" class="material-icons-round" *ngIf="item.requestStatus == 1" >pending</mat-icon>
          <mat-icon color="primary" class="material-icons-round" *ngIf="item.requestStatus == 2" >check_circle</mat-icon>
          <mat-icon color="primary" class="material-icons-round" *ngIf="item.requestStatus == 3" >cancel</mat-icon>
          <!-- <img [src]="item.imgThumbUrl" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'"> -->
        </div>
      </mat-card-title-group>
    </mat-card>
  </div>
  
 
</div>

<ng-container *ngIf="employeeData.length == 0 && !loader">
  <!-- <div class="py-5 text-center">
    <h3 class="text-muted">No data found</h3>
  </div> -->
  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        {{ 'employee_invitation.text' | translate }}
      </h3>
      <p>
        {{ 'employee_invitation.subtext' | translate }}
      </p>
    </div>
  </div>   
</ng-container>